module.exports = __webpack_public_path__ + "img/one_3.5b5ac200.png";